
import { startTransition } from 'react';

export const useCallStateManager = (
  setCallInProgress: (value: boolean) => void,
  setCallStatus: (status: string) => void,
  setCallStartTime: (time: Date) => void,
  setCallSid: (sid: string) => void,
  setIsMuted: (muted: boolean) => void,
  setActiveContactId: (contactId: number | null) => void,
  setActiveContactName: (contactName: string | null) => void,
  resetCallState: () => void,
  endCallState: () => void
) => {
  const updateCallToConnecting = (contactId?: number, contactName?: string) => {
    console.log('🚀 Setting call in progress and status to connecting', { contactId, contactName });
    startTransition(() => {
      setCallInProgress(true);
      setCallStatus('connecting');
      setCallStartTime(new Date());
      if (contactId !== undefined) setActiveContactId(contactId);
      if (contactName !== undefined) setActiveContactName(contactName);
    });
  };

  const updateCallSid = (callSid: string) => {
    console.log('🔍 [STATE] Updating CallSid to:', callSid);
    startTransition(() => {
      setCallSid(callSid);
    });
  };

  const updateCallStatus = (status: string, callSid?: string) => {
    startTransition(() => {
      if (status === 'open') {
        setCallStatus('open');
      } else if (status === 'ringing') {
        setCallStatus('ringing');
      }
      
      if (callSid) {
        setCallSid(callSid);
      }
    });
  };

  const resetCall = () => {
    startTransition(() => {
      resetCallState();
    });
  };

  const endCall = () => {
    startTransition(() => {
      endCallState();
    });
  };

  return {
    updateCallToConnecting,
    updateCallSid,
    updateCallStatus,
    resetCall,
    endCall
  };
};
